import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Post from 'flarum/forum/components/Post';
export default function downloadButtonInteraction() {
  extend(Post.prototype, 'oncreate', function () {
    this.$('[data-fof-upload-download-uuid]').unbind('click').on('click', e => {
      var _this$attrs$post$id;
      e.preventDefault();
      e.stopPropagation();
      if (!app.forum.attribute('fof-upload.canDownload')) {
        alert(app.translator.trans('fof-upload.forum.states.unauthorized'));
        return;
      }
      const target = e.currentTarget;
      let url = app.forum.attribute('apiUrl') + '/fof/download';
      url += '/' + encodeURIComponent(target.dataset.fofUploadDownloadUuid || '');
      url += '/' + encodeURIComponent((_this$attrs$post$id = this.attrs.post.id()) != null ? _this$attrs$post$id : '');
      url += '/' + encodeURIComponent(app.session.csrfToken);
      window.open(url);
    });
  });
}